const DEFAULT_VALUES = {
  logo: null,
  previewImage: null,
  primaryColor: null,
  secondaryColor: null,
  id: null,
};

export class GeneralSettingModel {
  logo: string;
  previewImage: string;
  primaryColor: string;
  secondaryColor: string;
  id: number;

  constructor(userLogin: object = DEFAULT_VALUES) {
    Object.assign(this, userLogin);
  }
}
